import { VideoMeeting } from "../models/video-meeting.model";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class MockMeetingsService {

  constructor() {
  }

  getMockMeetings(): VideoMeeting[] {
    const mockMeetings: VideoMeeting[] = [];
    for (let i = 0; i < 3; i++) {
      let meeting: VideoMeeting = {
        doctor: {
          employeeCode: "D07691",
          id: 4,
          person: {
            birthDate: "1979-07-24",
            firstName: "TAAVI",
            genderCodeId: 115,
            id: 4,
            insertTime: "2015-07-21T06:49:44.974+0000",
            lastName: "TASUJA",
            personalCode: "37907242744",
            type: "person",
            updateTime: "2020-06-17T09:26:43.943+0000",
          },
          profession: "11",
          registerChangeDate: "2014-03-18",
          registerInsertDate: "2014-03-18",
          speciality: "E380",
          type: "employee",
        },
        doctorId: 4,
        employeeId: 4,
        id: i,
        insertTime: "2020-03-31T13:48:14.527+0000",
        meetingTime: new Date().getTime() - 960000 + i * 960000,
        patient: {
          birthDate: "1967-06-19",
          firstName: "MARGIT",
          genderCodeId: 116,
          id: 2,
          insertTime: "2015-07-21T06:49:41.733+0000",
          lastName: "KONNO",
          personalCode: "46706196025",
          type: "person",
          updateTime: "2020-06-10T12:16:20.403+0000",
        },
        patientId: 2,
        person: {
          birthDate: "1967-06-19",
          firstName: "MARGIT",
          genderCodeId: 116,
          id: 2,
          insertTime: "2015-07-21T06:49:41.733+0000",
          lastName: "KONNO",
          personalCode: "46706196025",
          type: "person",
          updateTime: "2020-06-10T12:16:20.403+0000",
        },
        personId: 2,
        registerId: 3,
        representerPersonId: 2,
        roomCode: "3103202018004dewkcmgna",
        roomPassword: "2xl9s1f1764vrdwmg5xp3vj3ycql9vl8vw2nsiraky9xj50hhpb4",
        status: {
          type: "classificatorCode",
          id: 580,
          classificatorSystemId: 44,
          code: "PENDING",
          name: "ootel",
          insertTime: "2015-07-21T06:49:41.733+0000",
        },
        statusId: 580,
        type: {
          classificatorSystemId: 45,
          code: "VIDEO",
          id: 583,
          insertTime: "2020-03-28T19:21:09.334+0000",
          name: "videovisiit",
          type: "classificatorCode",
        },
        typeId: 583,
        updateTime: "2020-04-28T05:22:55.786+0000",
      };
      mockMeetings.push(meeting);
    }
    return mockMeetings;
  }
}



